import { useEffect } from "react";
import axios from "axios";
import { baseurl } from "../CoocpeatHome";
import { useNavigate } from "react-router-dom";

function PaymentVerify() {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const txnId = params.get("txnId");

      if (!txnId) return navigate("/Cart");

      try {
        const place = await axios.post(`${baseurl}products/placeorder`, {
          products: JSON.parse(localStorage.getItem("orderProducts")),
          totalPrice: localStorage.getItem("orderAmount"),
          customerDetails: JSON.parse(localStorage.getItem("customerDetails")),
          deliveryType: localStorage.getItem("deliveryType"),
          deliveryDate: localStorage.getItem("deliveryDate"),
        });

        console.log("Order response:", place);

        if (place.status === 201) {
          const id = place.data.orderNo;
          navigate(`/PaymentSuccess?orderNo=${id}`);
        } else {
          navigate("/Cart");
        }
      } catch (err) {
        console.log("Order error:", err);
        navigate("/Cart");
      }
    };

    run();
  }, []);

  return <h2>Processing Payment...</h2>;
}

export default PaymentVerify;
